import { InjectionToken } from '@angular/core';

/** Where a reload lands. The same default landing route AuthCallback uses after a real login. */
export const RELOAD_LANDING_ROUTE = '/home';

/**
 * Full document navigation — either a reload of the SPA at a given internal route, or an external
 * redirect (any absolute URL works with window.location.assign, not just a same-app path).
 *
 * Used when the *acting* identity changes — impersonation start and stop. Nearly everything the
 * app holds about a user is built once per page load and keyed by nothing an identity switch
 * invalidates: RightsService's signals (loaded once from App's constructor), CurrentUserService's
 * httpResource. Reloading the document is what actually gives the new identity a clean app, rather
 * than chasing each cache with its own refresh call and missing the next one somebody adds.
 *
 * Safe to do: the impersonation state itself lives in sessionStorage and the OIDC library keeps
 * the real session's tokens in localStorage, so both survive the reload — the user is not sent
 * back through login.
 *
 * Also used by app-shell.ts's promptImpersonate() to leave the app entirely for the broker-hosted
 * impersonation picker (Pages/Impersonate.cshtml) — a different reason (navigating away to pick a
 * target, not an identity switch yet), but the same underlying operation and the same need for a
 * mockable seam in specs.
 *
 * A token rather than a direct `window.location` call so specs can assert the navigation happened
 * without navigating the test runner out from under itself.
 */
export const APP_RELOAD = new InjectionToken<(path: string) => void>('APP_RELOAD', {
  providedIn: 'root',
  factory: () => (path: string) => window.location.assign(path),
});
